import apiClient from "../../axios/apiClient";

export const getDestinationList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_DESTINATIONLIST_PENDING" });

        const response = await apiClient.get(
          `/api/v1/destinations`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_DESTINATIONLIST_FULFILLED",
          payload: response.data?.data,
          destinationCount: response.data?.count,
          permissions: response.data?.permissions,
        });
      } catch (error) {
        dispatch({
          type: "GET_DESTINATIONLIST_REJECTED",
          payload: error.response,
        });
      }
    };


export const saveDestinationData = (token, data) => async (dispatch) => {
  try {
    dispatch({ type: "ADD_DESTINATION_PENDING" });

    const response = await apiClient.post(
      `/api/v1/destinations`,
      data, // Data payload should be the second argument
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_DESTINATION_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "ADD_DESTINATION_REJECTED", payload: error.response });
  }
};


export const getDestinationListById = (token, id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_DESTINATIONLISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/v1/destinations/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_DESTINATIONLISTBYID_FULFILLED",
        payload: response.data?.data,
        destinationCount: response.data?.count,
      });
    } catch (error) {
      dispatch({
        type: "GET_DESTINATIONLISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateDestinationData = (token, data, id) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_DESTINATION_PENDING" });

    const response = await apiClient.put(
      `/api/v1/destinations/${id}`, // Endpoint URL with City ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_DESTINATION_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_DESTINATION_REJECTED", payload: error.response });
  }
};


// export const updateDestinationStatusData = (token, id, status) => async (dispatch) => {
//   try {
//     dispatch({ type: "UPDATE_DESTINATION_STATUS_PENDING" });
//     const data={
//       "status":status
//     }
//     const response = await apiClient.post(
//       `/api/admin/v1/Update-Destination-Status/${id}`,
//       data,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
//     dispatch({ type: "UPDATE_DESTINATION_STATUS_FULFILLED", payload: response.data });
//   } catch (error) {
//     dispatch({ type: "UPDATE_DESTINATION_STATUS_REJECTED", payload: error.response });
//   }
// };


export const deleteDestinationData = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_DESTINATION_PENDING" });

    const response = await apiClient.delete(
      `/api/v1/destinations/${id}`, // Endpoint URL with City ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_DESTINATION_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_DESTINATION_REJECTED", payload: error.response });
  }
};
